import React, { useEffect, useRef } from 'react';
import { Container, Graphics } from '@pixi/react';

import WebBottomContainer from '../../containers/web/bottom';
import MenuWrapper from '../../containers/common/menuWrapper';
import Notification from '../../containers/common/notification';
import WinLineWrapper from '../../containers/common/winLineWrapper';
import FreeBetWrapper from '../../containers/common/freeBetWrapper';
import GameLogoWrapper from '../../containers/common/gameLogoWrapper';
import WinPopupWrapper from '../../containers/common/winPopupWrapper';
import InfoSectionContainer from '../../containers/common/infoWrapper';
import GameBoardWrapper from '../../containers/common/gameBoardWrapper';
import LobbyIconWrapper from '../../containers/common/lobbyIconWrapper';
import ExpandWildWrapper from '../../containers/common/expandWildWrapper';
import JackPotInfoWrapper from '../../containers/common/jackPotInfoWrapper';
// import TournamentIconWrapper from '../../containers/common/tournamentIconWrapper';
import GameBackgroundWrapper from '../../containers/common/gameBackgroundWrapper';
import ConnectionPopupWrapper from '../../containers/common/connectionPopupWrapper';
import GameFreeSpinCountWrapper from '../../containers/common/freeSpinCountWrapper';
import FreeSpinCongratsPopupWrapper from '../../containers/common/freeSpinCongratsPopupWrapper';
import FreeSpinTotalWinPopupWrapper from '../../containers/common/freeSpinTotalWinPopupWrapper';

import Gamble from '../../components/common/gamble';
import JackpotScene from '../../components/common/jackpotScene';
import JackPotCongratsPopup from '../../components/common/jackpot/jackPotCongratsPopup';
import BoostedJackpot from '../../components/common/boostedJackpot';
import BoostedJackpotIcon from "../../components/common/boostedJackpotIcon";

function WebView({ setMask, reelContainerRef, winContainerRef, reelContainerConfig }) {
  const spriteMaskRef = useRef(null);
  useEffect(() => {
    if (spriteMaskRef.current) {
      setMask(spriteMaskRef.current);
    }
  }, [setMask, spriteMaskRef]);

  return (
    <Container>
      <GameBackgroundWrapper />
      <GameBoardWrapper />
      <Container ref={reelContainerRef} {...reelContainerConfig} name='ReelContainer'>
        <Graphics
          draw={(g) => {
            g.beginFill(0xff700b);
            g.drawRect(-90, -65, 890, 515);
          }}
          ref={(graphicsRef) => setMask(graphicsRef)}
        />
      </Container>
      <Container ref={winContainerRef} {...reelContainerConfig} name='WinContainer' />
      <GameLogoWrapper />
      <ExpandWildWrapper />
      <WinLineWrapper />
      <WinPopupWrapper />
      <WebBottomContainer />
      {/* <TournamentIconWrapper /> */}
      <LobbyIconWrapper />
      <BoostedJackpotIcon />
      <JackPotInfoWrapper />
      <Gamble />
      <FreeBetWrapper />
      <BoostedJackpot />
      <GameFreeSpinCountWrapper />
      <FreeSpinCongratsPopupWrapper />
      <FreeSpinTotalWinPopupWrapper />
      <InfoSectionContainer />
      <MenuWrapper />
      <JackPotCongratsPopup />
      <JackpotScene />
      <Notification />
      <ConnectionPopupWrapper />
    </Container>
  );
}

export default WebView;
